import { DOCUMENT, inject, InjectionToken, PLATFORM_ID, REQUEST } from '@angular/core';
import { isPlatformServer } from '@angular/common';

export type Cookies = {
  [k: string]: string;
};

export const COOKIES = new InjectionToken<() => Cookies>('COOKIES', {
  factory: () => {
    const isServer = isPlatformServer(inject(PLATFORM_ID));
    const request = inject(REQUEST);
    const document = inject(DOCUMENT);
    return function () {
      const rawCookies = isServer ? request?.headers?.get('cookie') || '' : document.cookie;

      return rawCookies
        ? Object.fromEntries(
            rawCookies.split(';').map((cookie) => {
              const [key, value] = cookie.trim().split('=');
              return [key, value];
            }),
          )
        : {};
    };
  },
});
